import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css' 
import { createPinia } from 'pinia'
// 数据持久化
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
// 引入全局 Less 文件
import '@/styles/global.less'
const app = createApp(App)
app.use(router)
app.use(Vant)
app.use(pinia)
app.mount('#app')
